var map = {
	"./amplify-amazon-button_5.entry.js": [
		1987,
		154
	],
	"./amplify-auth-container.entry.js": [
		1988,
		155
	],
	"./amplify-auth-fields_9.entry.js": [
		1989,
		156
	],
	"./amplify-authenticator.entry.js": [
		1990,
		144
	],
	"./amplify-button_3.entry.js": [
		1991,
		157
	],
	"./amplify-chatbot.entry.js": [
		2014,
		79
	],
	"./amplify-checkbox.entry.js": [
		1992,
		158
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		1993,
		145
	],
	"./amplify-container.entry.js": [
		1994,
		159
	],
	"./amplify-federated-buttons_2.entry.js": [
		1995,
		160
	],
	"./amplify-federated-sign-in.entry.js": [
		1996,
		161
	],
	"./amplify-form-field_4.entry.js": [
		1997,
		162
	],
	"./amplify-greetings.entry.js": [
		1998,
		163
	],
	"./amplify-icon-button.entry.js": [
		1999,
		164
	],
	"./amplify-icon.entry.js": [
		2000,
		146
	],
	"./amplify-link.entry.js": [
		2001,
		165
	],
	"./amplify-nav_2.entry.js": [
		2002,
		166
	],
	"./amplify-photo-picker.entry.js": [
		2003,
		167
	],
	"./amplify-picker.entry.js": [
		2004,
		168
	],
	"./amplify-radio-button_3.entry.js": [
		2005,
		147
	],
	"./amplify-s3-album.entry.js": [
		2006,
		10,
		169
	],
	"./amplify-s3-image-picker.entry.js": [
		2007,
		10,
		170
	],
	"./amplify-s3-image.entry.js": [
		2008,
		10,
		171
	],
	"./amplify-s3-text-picker.entry.js": [
		2009,
		10,
		172
	],
	"./amplify-s3-text.entry.js": [
		2010,
		10,
		173
	],
	"./amplify-select-mfa-type.entry.js": [
		2011,
		174
	],
	"./amplify-sign-in-button.entry.js": [
		2012,
		148
	],
	"./amplify-tooltip.entry.js": [
		2013,
		175
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1841;
module.exports = webpackAsyncContext;